import * as React from "react";
const SvgFiRrCommentDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-dollar_svg__a)">
      <path
        fill="#062147"
        d="M12.836.03A12.04 12.04 0 0 0 3.509 3.52a12.03 12.03 0 0 0-3.48 9.333C.469 19.208 6.082 24 13.083 24H19c2.757 0 5-2.243 5-5v-6.66C24 5.862 19.097.454 12.836.03M22 19c0 1.654-1.346 3-3 3h-5.917c-6.034 0-10.686-3.905-11.058-9.285a10.03 10.03 0 0 1 2.898-7.782 10.02 10.02 0 0 1 7.778-2.91C17.915 2.377 22 6.91 22 12.34zm-6-5c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 1 1 1.73-1c.179.307.51.5.867.5h2.268c.552 0 1-.45 1-1a.77.77 0 0 0-.644-.76l-3.041-.508A2.76 2.76 0 0 1 7.999 10c0-1.654 1.346-3 3-3V6a1 1 0 1 1 2 0v1h.268c1.067 0 2.063.575 2.598 1.5a1 1 0 1 1-1.73 1.001 1 1 0 0 0-.867-.5H11c-.552 0-1 .45-1 1 0 .378.27.698.644.76l3.04.507A2.76 2.76 0 0 1 16 14.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentDollar;
